exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-select-branch .el-input__inner{border-color:#F56C6C}.error-branch{font-size:12px !important;color:#F56C6C;line-height:20px !important}\n", ""]);

// exports
